<div class="propero-home">
  <!-- Hero -->
  <section id="home" class="ph-hero">
    <div class="ph-hero__blob ph-hero__blob--brand" aria-hidden="true"></div>
    <div class="ph-hero__blob ph-hero__blob--accent" aria-hidden="true"></div>

    <div class="ph-container ph-hero__grid">
      <div class="ph-hero__content">
        <div class="ph-hero__badge">
          <span class="ph-hero__badge-dot" aria-hidden="true"></span>
          Nou: Scoring AI chiriași
        </div>

        <div class="ph-hero__copy" aria-live="polite">
          <div
            *ngFor="let slide of heroSlides; let i = index"
            class="ph-hero__slide"
            [class.ph-hero__slide--active]="i === heroSlideIndex"
            [attr.aria-hidden]="i !== heroSlideIndex">
            <h1 class="ph-hero__title">{{ slide.titleKey | translate }}</h1>
            <p class="ph-hero__subtitle">{{ slide.subtitleKey | translate }}</p>
          </div>
        </div>

        <div class="ph-hero__actions">
          <div class="ph-hero__cta-primary-wrap">
            <a [href]="assistantHref" target="_blank" rel="noopener noreferrer" class="ph-btn ph-btn--brand ph-btn--lg">
              Propero Assistant
            </a>
            <p class="ph-hero__cta-note">{{ 'HOME.MAIN_SUBTITLE_ADDITIONAL_TEXT' | translate }}</p>
          </div>
          <a routerLink="/solution-personalised" class="ph-btn ph-btn--outline ph-btn--lg">
            {{ 'HOME.MAIN_PERSONALIZED_OFFER' | translate }}
          </a>
        </div>

        <div class="ph-hero__dots" role="tablist" aria-label="Hero slides">
          <button
            *ngFor="let slide of heroSlides; let i = index"
            type="button"
            class="ph-hero__dot"
            [class.ph-hero__dot--active]="i === heroSlideIndex"
            [attr.aria-selected]="i === heroSlideIndex"
            [attr.aria-label]="'Slide ' + (i + 1)"
            (click)="setHeroSlide(i)">
          </button>
        </div>
      </div>

      <div class="ph-hero__visual">
        <div class="ph-hero__visual-shadow" aria-hidden="true"></div>
        <div class="ph-hero__image-stack">
          <img
            *ngFor="let slide of heroSlides; let i = index"
            [src]="slide.image"
            alt="Dashboard Propero pentru management imobiliar"
            class="ph-hero__image"
            [class.ph-hero__image--active]="i === heroSlideIndex"
            [attr.aria-hidden]="i !== heroSlideIndex" />
        </div>
      </div>
    </div>
  </section>

  <!-- Personas -->
  <section id="how-it-works" class="ph-section ph-section--muted">
    <div class="ph-container">
      <div class="ph-section__header ph-section__header--center">
        <h2 class="ph-section__title">{{ 'HOME.HOW_IT_WORKS_PRICE_TITLE' | translate }}</h2>
        <p class="ph-section__lead">{{ 'HOME.HOW_IT_WORKS_PRICE_TEXT' | translate }}</p>
      </div>

      <div class="ph-personas__grid">
        <article class="ph-card ph-card--hover">
          <div class="ph-card__tag-row">
            <span class="ph-card__tag">Proprietar</span>
          </div>
          <h3 class="ph-card__title-sm">{{ 'HOME.HOW_IT_WORK_OPTION_OWNER_TITLE' | translate }}</h3>
          <ul class="ph-list">
            <li>{{ 'HOME.HOW_IT_WORK_OPTION_OWNER_F1' | translate }}</li>
            <li>{{ 'HOME.HOW_IT_WORK_OPTION_OWNER_F2' | translate }}</li>
            <li>{{ 'HOME.HOW_IT_WORK_OPTION_OWNER_F3' | translate }}</li>
            <li>{{ 'HOME.HOW_IT_WORK_OPTION_OWNER_F4' | translate }}</li>
          </ul>
          <a [href]="assistantHref + '/register'" target="_blank" rel="noopener noreferrer" class="ph-link">
            {{ 'HOME.USER_REGISTER' | translate }} →
          </a>
        </article>

        <article class="ph-card ph-card--hover">
          <div class="ph-card__tag-row">
            <span class="ph-card__tag">Manager</span>
          </div>
          <h3 class="ph-card__title-sm">{{ 'HOME.HOW_IT_WORK_OPTION_MANAGER_TITLE' | translate }}</h3>
          <ul class="ph-list">
            <li>{{ 'HOME.HOW_IT_WORK_OPTION_MANAGER_F1' | translate }}</li>
            <li>{{ 'HOME.HOW_IT_WORK_OPTION_MANAGER_F2' | translate }}</li>
            <li>{{ 'HOME.HOW_IT_WORK_OPTION_MANAGER_F3' | translate }}</li>
            <li>{{ 'HOME.HOW_IT_WORK_OPTION_MANAGER_F4' | translate }}</li>
          </ul>
          <a [href]="assistantHref + '/register'" target="_blank" rel="noopener noreferrer" class="ph-link">
            {{ 'HOME.USER_REGISTER' | translate }} →
          </a>
        </article>

        <article class="ph-card ph-card--hover">
          <div class="ph-card__tag-row">
            <span class="ph-card__tag">Utilizator</span>
            <span class="ph-badge">TRIAL</span>
          </div>
          <h3 class="ph-card__title-sm">{{ 'HOME.HOW_IT_WORK_OPTION_AGENT_TITLE' | translate }}</h3>
          <ul class="ph-list">
            <li>{{ 'HOME.HOW_IT_WORK_OPTION_AGENT_F1' | translate }}</li>
            <li>{{ 'HOME.HOW_IT_WORK_OPTION_AGENT_F2' | translate }}</li>
            <li>{{ 'HOME.HOW_IT_WORK_OPTION_AGENT_F3' | translate }}</li>
            <li>{{ 'HOME.HOW_IT_WORK_OPTION_AGENT_F4' | translate }}</li>
          </ul>
          <a [href]="assistantHref + '/register'" target="_blank" rel="noopener noreferrer" class="ph-link">
            {{ 'HOME.USER_REGISTER' | translate }} →
          </a>
        </article>
      </div>

      <div class="ph-personas__wide">
        <article class="ph-card ph-card--dark ph-card--hover">
          <span class="ph-card__tag ph-card__tag--accent">Management Propero</span>
          <h3 class="ph-card__title-sm">{{ 'HOME.HOW_IT_WORK_OPTION_PROPERO_TITLE' | translate }}</h3>
          <p class="ph-card__text">{{ 'HOME.HOW_IT_WORK_OPTION_PROPERO_TEXT' | translate }}</p>
          <a routerLink="/collaboration" fragment="contact" class="ph-link ph-link--accent">
            {{ 'HOME.USER_LEARN_MORE' | translate }} →
          </a>
        </article>

        <article class="ph-card ph-card--hover">
          <span class="ph-card__tag">Agenție</span>
          <h3 class="ph-card__title-sm">{{ 'HOME.HOW_IT_WORK_OPTION_AGENCY_TITLE' | translate }}</h3>
          <p class="ph-card__text ph-card__text--muted">{{ 'HOME.HOW_IT_WORK_OPTION_AGENCY_TEXT' | translate }}</p>
          <a routerLink="/collaboration" class="ph-link">
            {{ 'HOME.USER_DISCOVER_SOLUTION' | translate }} →
          </a>
        </article>
      </div>

      <div class="ph-stats">
        <div class="ph-stats__item">
          <div class="ph-stats__value">{{ 'HOME.STATISTICS_ACTIVE_CLIENTS' | translate }}</div>
          <div class="ph-stats__label">{{ 'HOME.STATISTICS_ACTIVE_CLIENTS_TEXT' | translate }}</div>
        </div>
        <div class="ph-stats__item">
          <div class="ph-stats__value">{{ 'HOME.STATISTICS_SUCCESS_RATE' | translate }}</div>
          <div class="ph-stats__label">{{ 'HOME.STATISTICS_SUCCESS_RATE_TEXT' | translate }}</div>
        </div>
        <div class="ph-stats__item">
          <div class="ph-stats__value">24/7</div>
          <div class="ph-stats__label">{{ 'HOME.DEDICATED_SUPPORT_TEXT' | translate }}</div>
        </div>
      </div>
    </div>
  </section>

  <!-- Solutions -->
  <section id="services" class="ph-section ph-section--solutions">
    <div class="ph-container">
      <div class="ph-section__header">
        <h2 class="ph-section__title">{{ 'HOME.OFFERED_SOLUTIONS' | translate }}</h2>
        <p class="ph-section__lead">{{ 'HOME.OFFERED_SOLUTIONS_DETAILS' | translate }}</p>
      </div>

      <div class="ph-solutions__grid">
        <a *ngFor="let s of solutions" [routerLink]="s.route" class="ph-solution-card">
          <div class="ph-solution-card__icon">
            <i class="lni" [ngClass]="s.icon"></i>
          </div>
          <h3 class="ph-solution-card__title">{{ s.titleKey | translate }}</h3>
          <p class="ph-solution-card__text">{{ s.textShortKey | translate }}</p>
          <span class="ph-solution-card__cta">
            {{ 'HOME.SOLUTION_CARD_DETAILS' | translate }}
            <i class="lni lni-arrow-right" aria-hidden="true"></i>
          </span>
        </a>
      </div>
    </div>
  </section>

  <!-- Pricing preview -->
  <section id="pricing" class="ph-section ph-section--muted">
    <div class="ph-container">
      <div class="ph-section__header ph-section__header--center">
        <h2 class="ph-section__title">{{ 'HOME.SECTION_PAYMENT_TITLE' | translate }}</h2>
        <p class="ph-section__lead">{{ 'HOME.SECTION_PAYMENT_TEXT' | translate }}</p>
      </div>

      <div class="ph-pricing__grid">
        <article class="ph-pricing-card">
          <div class="ph-pricing-card__name">{{ 'HOME.START_TITLE' | translate }}</div>
          <div class="ph-pricing-card__price">
            <ng-container *ngIf="getSubscriptionPriceDetails('start_subscription_monthly') as startPrice">
              <span>{{ startPrice.subscriptionPrice || '0.00' }}</span>
              <span class="ph-pricing-card__suffix">{{ startPrice.subscriptionCurrency || 'RON' }} {{ 'HOME.START_PRICE' | translate }}</span>
            </ng-container>
          </div>
          <p class="ph-pricing-card__desc">{{ 'HOME.START_FUNCTIONALITY_TEXT' | translate }}</p>
          <ul class="ph-pricing-card__features">
            <li>{{ 'HOME.START_ITEM1_TEXT' | translate }}</li>
            <li>{{ 'HOME.START_ITEM3_TEXT' | translate }}</li>
            <li>{{ 'HOME.START_ITEM7_TEXT' | translate }}</li>
          </ul>
          <a routerLink="/pricing" class="ph-btn ph-btn--dark ph-btn--block">{{ 'HOME.START_BUTTON' | translate }}</a>
        </article>

        <article class="ph-pricing-card ph-pricing-card--featured">
          <span class="ph-pricing-card__ribbon">Recomandat</span>
          <div class="ph-pricing-card__name">{{ 'HOME.SMART_TITLE' | translate }}</div>
          <div class="ph-pricing-card__price">
            <ng-container *ngIf="getSubscriptionPriceDetails('smart_subscription_monthly') as smartPrice">
              <span>{{ smartPrice.subscriptionPrice || '0.00' }}</span>
              <span class="ph-pricing-card__suffix">{{ smartPrice.subscriptionCurrency || 'RON' }} {{ 'HOME.SMART_PRICE' | translate }}</span>
            </ng-container>
          </div>
          <p class="ph-pricing-card__desc">{{ 'HOME.SMART_FUNCTIONALITY_TEXT' | translate }}</p>
          <ul class="ph-pricing-card__features">
            <li>{{ 'HOME.SMART_ITEM1_TEXT' | translate }}</li>
            <li>{{ 'HOME.SMART_ITEM4_TEXT' | translate }}</li>
            <li>{{ 'HOME.SMART_ITEM8_TEXT' | translate }}</li>
          </ul>
          <a routerLink="/pricing" class="ph-btn ph-btn--brand ph-btn--block">{{ 'HOME.SMART_BUTTON' | translate }}</a>
        </article>

        <article class="ph-pricing-card">
          <div class="ph-pricing-card__name">{{ 'HOME.SCALE_TITLE' | translate }}</div>
          <div class="ph-pricing-card__price">
            <ng-container *ngIf="getSubscriptionPriceDetails('scale_subscription_monthly') as scalePrice">
              <span>{{ scalePrice.subscriptionPrice || '0.00' }}</span>
              <span class="ph-pricing-card__suffix">{{ scalePrice.subscriptionCurrency || 'RON' }} {{ 'HOME.SCALE_PRICE' | translate }}</span>
            </ng-container>
          </div>
          <p class="ph-pricing-card__desc">{{ 'HOME.SCALE_FUNCTIONALITY_TEXT' | translate }}</p>
          <ul class="ph-pricing-card__features">
            <li>{{ 'HOME.SCALE_ITEM1_TEXT' | translate }}</li>
            <li>{{ 'HOME.SCALE_ITEM4_TEXT' | translate }}</li>
            <li>{{ 'HOME.SCALE_ITEM9_TEXT' | translate }}</li>
          </ul>
          <a routerLink="/pricing" class="ph-btn ph-btn--dark ph-btn--block">{{ 'HOME.SCALE_BUTTON' | translate }}</a>
        </article>

        <article class="ph-pricing-card ph-pricing-card--dark">
          <div class="ph-pricing-card__name">{{ 'HOME.MANAGEMENT_PROPERO_TITLE' | translate }}</div>
          <div class="ph-pricing-card__price">
            <span>{{ 'HOME.MANAGEMENT_PROPERO_PRICE' | translate }}</span>
          </div>
          <p class="ph-pricing-card__desc">{{ 'HOME.MANAGEMENT_PROPERO_FUNCTIONALITY_TEXT' | translate }}</p>
          <ul class="ph-pricing-card__features">
            <li>{{ 'HOME.MANAGEMENT_PROPERO_ITEM2_TEXT' | translate }}</li>
            <li>{{ 'HOME.MANAGEMENT_PROPERO_ITEM6_TEXT' | translate }}</li>
            <li>{{ 'HOME.MANAGEMENT_PROPERO_ITEM11_TEXT' | translate }}</li>
          </ul>
          <a routerLink="/contact" class="ph-btn ph-btn--accent ph-btn--block">
            {{ 'HOME.MANAGEMENT_PROPERO_BUTTON' | translate }}
          </a>
        </article>
      </div>
    </div>
  </section>

  <!-- Resources -->
  <section id="resources" class="ph-section ph-section--resources">
    <div class="ph-container">
      <div class="ph-section__header">
        <h2 class="ph-section__title">{{ 'HOME.SECTION_RESOURCES_TITLE' | translate }}</h2>
        <p class="ph-section__lead">{{ 'HOME.SECTION_RESOURCES_TEXT' | translate }}</p>
      </div>

      <div class="ph-resources__grid">
        <a *ngFor="let r of resources" [routerLink]="r.route" class="ph-resource-card">
          <div class="ph-resource-card__icon">
            <i class="lni" [ngClass]="r.icon"></i>
          </div>
          <h3 class="ph-resource-card__title">{{ r.titleKey | translate }}</h3>
          <p class="ph-resource-card__text">{{ r.textShortKey | translate }}</p>
          <span class="ph-resource-card__cta">
            {{ 'HOME.SOLUTION_CARD_DETAILS' | translate }}
            <i class="lni lni-arrow-right" aria-hidden="true"></i>
          </span>
        </a>
      </div>
    </div>
  </section>

  <!-- Blog -->
  <section id="blog" class="ph-section ph-section--muted">
    <div class="ph-container">
      <div class="ph-section__header ph-section__header--split">
        <div>
          <h2 class="ph-section__title">{{ 'HOME.SECTION_BLOG_TITLE' | translate }}</h2>
          <p class="ph-section__lead">{{ 'HOME.SECTION_BLOG_TEXT' | translate }}</p>
        </div>
        <a routerLink="/blog-list" class="ph-btn ph-btn--outline">Toate articolele →</a>
      </div>

      <div class="ph-blog__grid" *ngIf="latestBlogItems.length; else blogPlaceholder">
        <article *ngFor="let blogItem of latestBlogItems" class="ph-blog-card">
          <div class="ph-blog-card__media">
            <img
              [src]="blogItem.imageURL || 'assets/images/blog/1.jpg'"
              [alt]="blogItem.title"
              class="ph-blog-card__img" />
          </div>
          <div class="ph-blog-card__body">
            <div class="ph-blog-card__meta">
              <span class="ph-blog-card__category">
                {{ (blogItem.blogCategory || blogItem['BlogCategory'])?.name || ('HOME.NO_CATEGORY' | translate) }}
              </span>
              <span>{{ blogItem.publishedDate | date: 'dd MMM yyyy' }}</span>
              <span>· {{ blogItem.commentsCount || 0 }} {{ 'HOME.COMMENTS' | translate }}</span>
            </div>
            <h3 class="ph-blog-card__title">{{ blogItem.title }}</h3>
            <p class="ph-blog-card__excerpt">{{ blogItem.summary || ('HOME.BLOG_NO_SUMMARY' | translate) }}</p>
            <a
              class="ph-link"
              routerLink="/blog-post"
              [queryParams]="{ id: blogItem.id }">
              {{ 'HOME.READ_MORE' | translate }} →
            </a>
          </div>
        </article>
      </div>

      <ng-template #blogPlaceholder>
        <div class="ph-blog__grid">
          <article *ngFor="let i of [1, 2, 3]" class="ph-blog-card">
            <div class="ph-blog-card__media ph-blog-card__media--placeholder"></div>
            <div class="ph-blog-card__body">
              <p class="ph-blog-card__excerpt ph-skeleton">Se încarcă articolele...</p>
            </div>
          </article>
        </div>
      </ng-template>
    </div>
  </section>

  <!-- FAQ -->
  <section id="about" class="ph-section">
    <div class="ph-container ph-container--narrow">
      <div class="ph-section__header ph-section__header--center">
        <h2 class="ph-section__title">{{ 'HOME.SECTION_FAQ_TITLE' | translate }}</h2>
        <p class="ph-section__lead">{{ 'HOME.SECTION_FAQ_TEXT' | translate }}</p>
      </div>

      <div class="ph-faq">
        <div *ngFor="let item of faqItems; let i = index" class="ph-faq__item">
          <button type="button" class="ph-faq__trigger" (click)="toggleFaq(i)" [attr.aria-expanded]="openFaqIndex === i">
            <span>{{ item.questionKey | translate }}</span>
            <i class="lni lni-chevron-down ph-faq__chevron" [class.ph-faq__chevron--open]="openFaqIndex === i"></i>
          </button>
          <div class="ph-faq__panel" *ngIf="openFaqIndex === i">
            <p>{{ item.answerKey | translate }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Contact -->
  <section id="contact" class="ph-section ph-section--contact">
    <div class="ph-container ph-contact__grid">
      <div class="ph-contact__info">
        <h2 class="ph-contact__title">{{ 'HOME.SECTION_CONTACTUS_HEADING' | translate }}</h2>
        <p class="ph-contact__lead">{{ 'HOME.SECTION_CONTACTUS_TEXT' | translate }}</p>

        <div class="ph-contact__channels">
          <div class="ph-contact__channel">
            <div class="ph-contact__channel-icon"><i class="lni lni-phone"></i></div>
            <div>
              <div class="ph-contact__channel-label">Telefon</div>
              <div class="ph-contact__channel-value">{{ 'COMPANY.CONTACT_MAIN_PHONE' | translate }}</div>
            </div>
          </div>
          <div class="ph-contact__channel">
            <div class="ph-contact__channel-icon"><i class="lni lni-envelope"></i></div>
            <div>
              <div class="ph-contact__channel-label">Email</div>
              <div class="ph-contact__channel-value">{{ 'COMPANY.CONTACT_MAIN_EMAIL' | translate }}</div>
            </div>
          </div>
        </div>
      </div>

      <form #contactForm="ngForm" (ngSubmit)="send()" class="ph-contact__form" novalidate>
        <div class="ph-field">
          <label for="contact-name">{{ 'HOME.NAME' | translate }}</label>
          <input
            id="contact-name"
            type="text"
            name="name"
            [(ngModel)]="contactItem.subject"
            required
            [placeholder]="'HOME.NAME' | translate" />
        </div>
        <div class="ph-field">
          <label for="contact-email">{{ 'HOME.EMAIL' | translate }}</label>
          <input
            id="contact-email"
            type="email"
            name="email"
            [(ngModel)]="contactItem.email"
            required
            email
            [placeholder]="'HOME.EMAIL' | translate" />
        </div>
        <div class="ph-field">
          <label for="contact-message">{{ 'HOME.MESSAGE' | translate }}</label>
          <textarea
            id="contact-message"
            name="message"
            rows="4"
            [(ngModel)]="contactItem.content"
            required
            [placeholder]="'HOME.MESSAGE' | translate"></textarea>
        </div>
        <button type="submit" class="ph-btn ph-btn--brand ph-btn--block ph-btn--lg" [disabled]="contactForm.invalid || isLoading">
          <span *ngIf="!isLoading">{{ 'HOME.SEND' | translate }}</span>
          <span *ngIf="isLoading">{{ 'HOME.SENDING' | translate }}</span>
        </button>
        <p *ngIf="contactSuccess" class="ph-contact__success">Mesaj trimis! Te contactăm în curând.</p>
      </form>
    </div>
  </section>
</div>
